import type { Wrex } from '@lumapps/wrex/types';

import { IFRAME } from '../constants';
import type { IframeElement } from '../types';

/** Create an iframe element */
export const createIframeElement = (attributes: Wrex.ElementAttributes<IframeElement>): IframeElement => {
    return { type: IFRAME, ...attributes, children: [{ text: '' }] };
};
